export class OmnisearchModel {
    bodyStyleTypeDisplayValue: string;
    makeDisplayValue: string;
    modelDisplayValue: string;
    modelYear: number;
    plateNumber: string;
    registrationEndDate: string;
    vehicleId: number;
    vehicleNumber: number;
    vehicleTypeDisplayValue: string;
    vin: string;

    constructor(source?: Partial<OmnisearchModel>) {
        Object.assign(this, source);
    }
}
